import 'material-design-icons-iconfont/dist/material-design-icons.css'

import Vue from 'vue'
import './plugins/vuetify'
import vuetify from '@/plugins/vuetify'

import App from './App.vue'
import router from './router'
import store from './store/index'
import axios from 'axios'
import {createProvider} from './vue-apollo'
import moment from 'vue-moment'

import { Buffer } from 'buffer'
window.Buffer = Buffer

import {Chart, CategoryScale, LinearScale, PointElement, LineElement} from 'chart.js'
Chart.register(CategoryScale)
Chart.register(LinearScale)
Chart.register(PointElement)
Chart.register(LineElement)

Vue.config.productionTip = false

const apollo = createProvider()

store.$axios = axios
store.$apollo = apollo.clients.defaultClient

Vue.use(moment)

router.beforeEach((to, from, next) => {
    if (store.state.user === null && to.name !== 'login' && to.name !== 'home') {
        next({name: 'login'})
    }
    next()
})

store.dispatch('user/logged').then(() => {
    new Vue({
        vuetify,
        router,
        store,
        apolloProvider: apollo,
        render: h => h(App)
    }).$mount('#app')
})

